export const csvData = [
    ["sku", "size", "price", "height", "length", "width", "weight", "additional_weight"],
    ["HOODIE_3D", "S", "2", "100", "50", "100", "24" , "30"]
]
